import { render, staticRenderFns } from "./collectionList.vue?vue&type=template&id=6698aed0&scoped=true&"
import script from "./collectionList.vue?vue&type=script&lang=js&"
export * from "./collectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698aed0",
  null
  
)

export default component.exports